const labels = {
  expiring: "Expiring",
  invalid: "Invalid",
  n_a: "Not Required",
  not_required: "Not Required",
  pending: "Pending",
  valid: "Valid",
  warning: "Expiring",
};

export const formatInformationalStatus = (value) => {
  const normalized = String(value || "").trim().toLowerCase();

  if (!normalized) {
    return "Not set";
  }

  if (labels[normalized]) {
    return labels[normalized];
  }

  return normalized
    .replaceAll("_", " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
};

export const InformationalStatusText = ({ label, testId }) => (
  <span className="informational-status-text" data-testid={testId}>
    {formatInformationalStatus(label)}
  </span>
);